import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {DeviceAdminDto} from '../../dtos/deviceAdminDto';

@Injectable({
    providedIn: 'root'
})
export class DeviceAdminService {

    constructor(private httpClient: HttpClient) {
    }

    public async findAllPagingWithNotificationsId(page: number): Promise<DeviceAdminDto[]> {
        const httpParams = new HttpParams().set('page', page.toString());

        return await this.httpClient.get<DeviceAdminDto[]>(environment.apiUrl + 'api/devices/admin/v1/findAllPagingWithNotificationsId',
            { params: httpParams })
            .toPromise();
    }
}
